import type { LicenseError } from "@/types/api";
import { ReactComponent as OrangeExclamation } from "@/assets/icons/Exclamation-Orange.svg";
import { cn } from "@/utils/utils";

type LicenseRedemptionRowFailureProps = {
  license: LicenseError;
} & React.HTMLAttributes<HTMLDivElement>;

export const LicenseRedemptionRowFailure: React.FC<LicenseRedemptionRowFailureProps> = ({
  license,
  className,
  ...divProps
}) => {
  return (
    <div className={cn("w-full p-3", className)} {...divProps}>
      <p className="font-bold text-xs">{license.licenseCode}</p>
      <div className="flex flex-row space-x-1">
        <OrangeExclamation className="size-4" />
        <p className="text-xs font-semibold" style={{ color: "var(--musio-orange)" }}>
          {license.error ? "Invalid" : null}
        </p>
      </div>
    </div>
  );
};
